import Swiper from "swiper";

// =============================================================================
// Definition
// =============================================================================
class Gallery {

	// Constructor
	// -------------------------------------------------------------------------
	constructor(el) {
		this.el = el;

        this.init();
        this.initEvents();
        this.initFullscreen();
        this.initFullscreenEvents();
	}

	// Inits
    // -------------------------------------------------------------------------
    init() {
        this.leftButton = this.el.querySelector(".swiper-button-prev");
        this.rightButton = this.el.querySelector(".swiper-button-next");
        this.container =  this.el.querySelector(".swiper");
        
        this.lightbox = this.el.querySelector(".lightboxContainer");
        this.imageContainer = this.el.querySelector(".lb-container");
        this.images = this.el.querySelectorAll(".swiper-slide.scale-on-hover");
        this.closeButton = this.el.querySelector(".popupClosingIconContainer");
        this.amountOfSlides = this.lightbox?.dataset?.slides;

        this.swiperCarousel = new Swiper(this.container, {
            spaceBetween: 12,
            slidesPerView: 1, 
            breakpoints: {
                640: {
                    slidesPerView: 2 
                },
                1080: {
                    spaceBetween: 24,
                    slidesPerView: 3 
                }
              }           
        });

        this.handleButtonStates();

        this.swiperCarousel.on("slideChange", () => {
            this.handleButtonStates()
        });
    }

    initEvents() {
        this.leftButton.addEventListener("click", () => this.handleClickLeft());
        this.rightButton.addEventListener("click", () => this.handleClickRight());
        this.images.forEach(image => {
            image.addEventListener("click", () => {
                this.handleImageClicked(image, event)
            })
        });
        this.lightbox?.addEventListener("click", (event) => {
            if(event.target.matches("img.popup-image") 
                || event.target.matches("div.swiper-button-prev") 
                || event.target.matches("div.swiper-button-next")){
                event.stopPropagation();
            }
            else{
                this.closeLightbox();
            }
        })
        this.closeButton?.addEventListener("click", () => this.closeLightbox()); 
    }

    initFullscreen(){
        // --- Fullscreen version ---

        this.container_fullscreen =  this.el.querySelector(".swiper.fullscreen");
        this.images_fullscreen = this.el.querySelectorAll(".swiper-slide.fullscreen");
        this.leftButton_fullscreen = this.el.querySelector(".swiper-button-prev.fullscreen");
        this.rightButton_fullscreen = this.el.querySelector(".swiper-button-next.fullscreen");        

        this.swiperCarousel_fullscreen = new Swiper(this.container_fullscreen, {
            spaceBetween: 12,
            slidesPerView: 1,
        });

        this.handleButtonStates(true);

        this.swiperCarousel_fullscreen.on("slideChange", () => {
            this.handleButtonStates(true);
        });
        this.swiperCarousel_fullscreen.on('activeIndexChange', () => {
            if(this.lightbox.style.display != "block"){
                // set fullscreen swiper component to visible
                this.lightbox.style.display = "block";
            }
        });
    }

    initFullscreenEvents() {
         // --- Fullscreen version ---
         this.leftButton_fullscreen?.addEventListener("click", () => this.handleClickLeft(true));
         this.rightButton_fullscreen?.addEventListener("click", () => this.handleClickRight(true));
    }

	// Handlers
    // -------------------------------------------------------------------------
    handleClickLeft(isFullscreen = false) {
        if(isFullscreen){
            if (!this.leftButton_fullscreen.classList?.contains("swiper-button-disabled")) {
                this.swiperCarousel_fullscreen.slidePrev(300);            
            }
        }
        else{
            if (!this.leftButton.classList?.contains("swiper-button-disabled")) {
                this.swiperCarousel.slidePrev(300);            
            }
        }
    }

    handleClickRight(isFullscreen = false) {
        if(isFullscreen){
            if (!this.rightButton_fullscreen.classList?.contains("swiper-button-disabled")) {
                this.swiperCarousel_fullscreen.slideNext(300);            
            }
        }
        else{
            if (!this.rightButton.classList?.contains("swiper-button-disabled")) {
                this.swiperCarousel.slideNext(300);
            }
        }
    }

    handleImageClicked(image, event) {     
        const clickedItemIndex = Array.from(this.images).indexOf(image); 
        this.swiperCarousel_fullscreen.slideTo(clickedItemIndex); 
        this.lightbox.style.display = "block";
        this.swiperCarousel_fullscreen.update();
    }

    closeLightbox() {
        this.lightbox.style.display = "none";
    }

    handleButtonStates(isFullscreen = false) {
        this.handleBetween(isFullscreen);
        this.handleBeginning(isFullscreen);
        this.handleEnd(isFullscreen);
    }

    handleBeginning(isFullscreen) {
        if(isFullscreen && this.leftButton_fullscreen){   
            if (this.swiperCarousel_fullscreen.isBeginning || this.swiperCarousel_fullscreen.activeIndex === 0) {  
                this.leftButton_fullscreen.classList?.add("swiper-button-disabled");
            }
        }
        else{
            if (this.swiperCarousel.isBeginning) {
                this.leftButton.classList?.add("swiper-button-disabled");
            }

        }
    }

    handleEnd(isFullscreen) {  
        if(isFullscreen && this.rightButton_fullscreen){
            if (this.swiperCarousel_fullscreen.isEnd || this.swiperCarousel_fullscreen.activeIndex === this.amountOfSlides - 1) {
                this.rightButton_fullscreen.classList?.add("swiper-button-disabled");
            }
        }
        else{
            if (this.swiperCarousel.isEnd) {
                this.rightButton.classList?.add("swiper-button-disabled");
            }
        }
    }

    handleBetween(isFullscreen) {
        if(isFullscreen && this.leftButton_fullscreen && this.rightButton_fullscreen){
            if (!this.swiperCarousel_fullscreen.isBeginning) {
                if (this.leftButton_fullscreen.classList?.contains("swiper-button-disabled")) {
                    this.leftButton_fullscreen.classList?.remove("swiper-button-disabled");
                }
            }
    
            if (!this.swiperCarousel_fullscreen.isEnd) {            
                if (this.rightButton_fullscreen.classList?.contains("swiper-button-disabled")) {
                    this.rightButton_fullscreen.classList?.remove("swiper-button-disabled");
                }
            }
        }
        else{
            if (!this.swiperCarousel.isBeginning) {
                if (this.leftButton.classList?.contains("swiper-button-disabled")) {
                    this.leftButton.classList?.remove("swiper-button-disabled");
                }
            }
    
            if (!this.swiperCarousel.isEnd) {            
                if (this.rightButton.classList?.contains("swiper-button-disabled")) {
                    this.rightButton.classList?.remove("swiper-button-disabled");
                }
            }
        }
    }
}

export default Gallery;
